/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Manageroles_Onerole2Inputs */

const en_settings_collaborators_manageroles_onerole2 = /** @type {(inputs: Settings_Collaborators_Manageroles_Onerole2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 role`)
};

/**
* | output |
* | --- |
* | "1 role" |
*
* @param {Settings_Collaborators_Manageroles_Onerole2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_onerole2 = /** @type {((inputs?: Settings_Collaborators_Manageroles_Onerole2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Onerole2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_onerole2(inputs)
});
export { settings_collaborators_manageroles_onerole2 as "settings_collaborators_manageRoles_oneRole" }